import { Text, Title } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { InformationPopover } from "@/molecules/InformationPopover"
import styles from "./DismissModal.module.scss"

export const IssueDismissInfo = ({
  count,
  entityType
}: {
  count: number
  entityType: string
}) => {
  const { t } = useTranslation()
  return (
    <>
      <Title className={styles.title} level={4}>
        {t("triage.dismiss_modal.title", { count, entityType })}
        <InformationPopover.Popover
          iconSize="large"
          classNamePopover={styles.popover}
          classNameIcon={styles.iconPopover}
          content={
            <InformationPopover.CommonTemplate>
              {t("triage.dismiss_modal.excludeFromSummary")}
            </InformationPopover.CommonTemplate>
          }
        />
      </Title>
      <Text>{t("triage.dismiss_modal.explain")}</Text>
    </>
  )
}
